// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"242":"1b415d0c","375":"18218062","468":"05340977","787":"2fb6503d","844":"049ae0ca"}[chunkId] + ".chunk.js";
};